import constate from 'constate'
import { useQueryClient } from 'react-query'
import { useFetchDatasets } from '../hooks/useFetchDatasets'
import { useDatasetsUpdate } from '../hooks/useDatasetsUpdate'
import { DATASETS_QUERY_KEY } from '../queries/useDatasetsQuery'
import { TDataset } from '../definitions'
import { useFiltersStateContext } from './useFiltersState'
import { useKeywordsStateContext } from './useKeywordsState'
import { useFiltersQuery } from '../queries/useFiltersQuery'

const useDatasets = () => {
  const { isFetching } = useFetchDatasets()
  const { isUpdating } = useDatasetsUpdate()
  const filtersData = useFiltersQuery(false).data
  const isFilterActive = !!useFiltersStateContext().getSelectedFiltersCount()
  const isSearchActive = !!useKeywordsStateContext().submittedKeywords
  const shouldAwaitFilters = (isFilterActive || isSearchActive) && !filtersData?.length

  return {
    isLoading: isUpdating || isFetching || shouldAwaitFilters,
    datasets: useQueryClient().getQueryData<TDataset[]>(DATASETS_QUERY_KEY)
  }
}

export const [DatasetsProvider, useDatasetsContext] = constate(useDatasets)
